import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { navigationItems, activeMenuItemKey } from './navigationItems';
import './NavigationMenu.component.scss';

export function NavigationMenuComponent(props: any) {
  return (
    <section className='navigation-menu-container d-flex justify-content-around align-items-center'>
      <div className='navigation-menu d-flex justify-content-between align-items-start'>
        {navigationItems.map((el, idx) => {
          if (
            props.route &&
            props.route.state &&
            props.route.state[activeMenuItemKey] &&
            el.activeMenuItem === props.route.state[activeMenuItemKey]
          ) {
            return (
              <div
                className='navigation-menu-selected-item-container'
                key={`navigation-menu-item-${idx + 1}`}
              >
                <Link to={el.path}>
                  <div className='navigation-menu-selected-item-image d-flex justify-content-center align-items-center'>
                    <img src={el.img} alt='img' />
                  </div>
                  <h4 className='navigation-menu-item-title'>
                    <FormattedMessage id={el.title}>
                      {text => text}
                    </FormattedMessage>
                  </h4>
                </Link>
              </div>
            );
          } else {
            return (
              <div
                className='navigation-menu-item-container'
                key={`navigation-menu-item-${idx + 1}`}
              >
                <Link to={el.path}>
                  <div className='navigation-menu-item-image d-flex justify-content-center align-items-center'>
                    <img src={el.img} alt='img' />
                  </div>
                </Link>
              </div>
            );
          }
        })}
      </div>
    </section>
  );
}
